import { Box, Chip, Typography } from '@mui/material';
import { CheckboxUI } from '../Interface';
import useParam from '../../context/ParamContext';
import { useEffect, useState } from 'react';
import { formatValue } from '../../utils/resource.planner';

const ChipContent = ({ eventInfo, selectedTaskState }) => {
  const { selectedTaskIds, setSelectedTaskIds } = selectedTaskState;
  const { params } = useParam();
  const [chipObj, setChipObj] = useState(null);

  useEffect(() => {
    let paramKey = 'PROJECT_EMPLOYEE_PLANNER_CHIP_CONTENT';

    if (params[paramKey]) {
      const parsedObj = JSON.parse(params[paramKey]);
      setChipObj(parsedObj);
    }
  }, [params]);

  const eventData = eventInfo.event._def.extendedProps.eventData;

  const getFieldValue = (obj, path) => {
    return path.split('.').reduce((acc, part) => {
      if (Array.isArray(acc)) {
        return acc.map((item) => item[part]);
      }
      return acc ? acc[part] : null;
    }, obj);
  };

  const setChipContent = () => {
    if (!chipObj || !eventData) {
      return null;
    }

    const stopFcPropagation = (e) => {
      e.stopPropagation();
    };

    return (
      <span>
        <Box display="flex" alignItems="center">
          {eventData.projectId && (
            <CheckboxUI
              onClick={stopFcPropagation}
              sx={{ m: 0, ml: -0.2, p: 0 }}
              checked={selectedTaskIds.includes(eventData.simpleTaskId)}
              onChange={() =>
                setSelectedTaskIds((prev) =>
                  prev.includes(eventData.simpleTaskId)
                    ? prev.filter((simpleTaskId) => simpleTaskId !== eventData.simpleTaskId)
                    : [...prev, eventData.simpleTaskId]
                )
              }
            />
          )}
        </Box>

        {chipObj.map((item, index) => {
          const { label, fieldName, type } = item;
          const taskValue = getFieldValue(eventData, fieldName);

          return (
            <span key={index} className="block">
              {label}: {formatValue(taskValue, type)}
            </span>
          );
        })}

        {eventData.resources.length > 0 && (
          <div style={{ marginTop: '4px', display: 'flex', flexDirection: 'column', gap: '2px' }}>
            {eventData.resources
              .filter((resource) => resource.employeeId)
              .map((resource) => (
                <Chip
                  key={resource.simpleTaskId}
                  label={resource.employee?.name}
                  title={resource.employee?.name}
                  size="small"
                  sx={{
                    backgroundColor: resource.leader ? '#ffb7b7' : '#e0e0e0',
                    color: resource.leader ? 'red' : '#424242',
                    height: 20,
                    '.MuiChip-label': { paddingLeft: 6, paddingRight: 6 },
                  }}
                />
              ))}
          </div>
        )}
      </span>
    );
  };

  return <div>{setChipContent()}</div>;
};

export default ChipContent;
